var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg137(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.66,57.28,88,75,60.66,89.79l26.59,13.3-26.59,14L88,130.42l-27.31,14,26.59,14-25.88,14,26.6,14m73.18-87.9a7.24,7.24,0,1,0,6.59-10.35V75.75m-107-42.11v159H88V32.91L74.31,26.25Zm-.81,34.72L40.53,55.06H180l-5.75,20.69H161.28l-7.19-18.47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg137);
export default __webpack_public_path__ + "static/media/_137.7f10287be4798bb5f20633514f56698a.svg";
export { ForwardRef as ReactComponent };